// extracted by mini-css-extract-plugin
export var growableInput = "_63-0";
export var tagContainer = "_63-2";
export var textInput = "_63-1";